import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'pink' | 'orange' | 'yellow' | 'blue' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'pink',
  size = 'md',
  href,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-colors duration-300';
  const variants = {
    pink: 'bg-jany-pink text-white hover:bg-[#ff528a]',
    orange: 'bg-jany-orange text-white hover:bg-[#ff7620]',
    yellow: 'bg-jany-yellow text-jany-dark hover:bg-[#ffca2b]',
    blue: 'bg-jany-blue text-jany-dark hover:bg-[#a6d5ff]',
    outline: 'bg-transparent border-2 border-jany-dark text-jany-dark hover:bg-jany-dark hover:text-jany-cream'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  const hoverAnimation = {
    scale: 1.05,
    rotate: variant === 'outline' ? 0 : 2,
    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)'
  };
  const tapAnimation = {
    scale: 0.95,
    rotate: 0
  };
  const transition = {
    type: 'spring',
    stiffness: 300,
    damping: 15
  };
  if (href) {
    // Wrap Link in motion.div to animate it
    return <motion.div whileHover={hoverAnimation} whileTap={tapAnimation} transition={transition} className="inline-block" data-id="element-76">
        <Link to={href} className={classes} data-id="element-77">
          {children}
        </Link>
      </motion.div>;
  }
  return <motion.button whileHover={hoverAnimation} whileTap={tapAnimation} transition={transition} className={classes} {...props} data-id="element-78">
      {children}
    </motion.button>;
}